module.exports = __webpack_public_path__ + "static/media/kobe.51920051.PNG";